"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _hooks = require("../../../hooks");

var _BrandSkeletonStack = _interopRequireDefault(require("../../BrandSkeletonStack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SlideImage = function SlideImage(_ref) {
  var highQuality = _ref.highQuality,
      lowQuality = _ref.lowQuality,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '275px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;
  var src = highQuality;
  var blur = false;

  var _useProgressiveImg = (0, _hooks.useProgressiveImg)(lowQuality, highQuality);

  var _useProgressiveImg2 = _slicedToArray(_useProgressiveImg, 2);

  src = _useProgressiveImg2[0];
  blur = _useProgressiveImg2[1].blur;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      width: width,
      minHeight: height,
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_BrandSkeletonStack.default, {
    height: "100%",
    width: "100%",
    sx: {
      position: 'absolute',
      zIndex: -1
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "rectangular",
    width: "100%",
    sx: {
      borderRadius: '6px 6px 0 0'
    },
    height: height
  })), src && /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    alt: "slide-step",
    style: {
      display: 'flex',
      width: '100%',
      height: '100%',
      filter: blur ? 'blur(10px)' : 'none',
      transition: blur ? 'none' : 'filter 0.5s ease-out',
      borderRadius: '6px 6px 0 0'
    }
  }));
};

SlideImage.propTypes = {
  highQuality: _propTypes.default.string,
  lowQuality: _propTypes.default.string
};
var _default = SlideImage;
exports.default = _default;